import axios from 'axios';

export async function getMedRequest(id) {
    const url = `/api/medRequest${id ? '/' + id : ''}`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then(async (response) => {
                const medRequests = response.data.data.flat();
                const formattedMedRequests = await Promise.all(
                    medRequests.map(async (medRequest) => {
                        return {
                            id: medRequest.identifier[0].value,
                            periodoLimiteInicio:
                                medRequest.dispenseRequest.validityPeriod.start,
                            periodoLimiteFinal:
                                medRequest.dispenseRequest.validityPeriod.end,
                            instruccionesDosis:
                                medRequest.dosageInstruction[0].text,
                            medicamento:
                                medRequest.medicationReference?.display,
                            status: medRequest.status,
                            medico: medRequest.practitionerName,
                            note: medRequest.note[0].text,
                        };
                    }),
                );
                resolve(formattedMedRequests);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getMedRequestByPractitionerId(id) {
    const url = `/api/medRequest/practitioner${id ? '/' + id : ''}`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then(async (response) => {
                const medRequests = response.data.data.flat();
                const formattedMedRequests = await Promise.all(
                    medRequests.map(async (medRequest) => {
                        return {
                            id: medRequest.identifier[0].value,
                            periodoLimiteInicio:
                                medRequest.dispenseRequest.validityPeriod.start,
                            periodoLimiteFinal:
                                medRequest.dispenseRequest.validityPeriod.end,
                            instruccionesDosis:
                                medRequest.dosageInstruction[0].text,
                            medicamento:
                                medRequest.medicationReference?.display,
                            status: medRequest.status,
                            paciente: medRequest.subject,
                        };
                    }),
                );
                resolve(formattedMedRequests);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function cancelMedRequestById(prescriptionId) {
    const url = `/api/medRequest/${prescriptionId}`;
    return new Promise((resolve, reject) => {
        axios
            .put(url)
            .then(async (response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
